import { render, staticRenderFns } from "./ScholarshipAddNew.vue?vue&type=template&id=7564ca1b"
import script from "./ScholarshipAddNew.vue?vue&type=script&lang=js"
export * from "./ScholarshipAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports